import { destroy, mutate, query, update, uploadFile } from "../../defaults/fetch";
import { useState, useEffect } from "react";

// Search items
export const searchItems = async (keyword, page = 0, size = 50) => {
  const qs = {
    keyword,
    page,
    size
  };
  const url = `inventory/item/search`;
  const { data } = await query(url, qs);
  return data;
}

// Get all items
export const getItems = async (departmentId, categoryId, page = 0, size = 50) => {
  const qs = {
    department: departmentId,
    category: categoryId,
    page: page,
    size: size
  };
  const url = `inventory/item`;
  const { data } = await query(url, qs);
  return data;
}

export const useGetAllItems = (departmentId, categoryId, flag) => {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const getAllItems = async () => {
      if (!departmentId) return;

      const qs = {
        department: departmentId,
        category: categoryId,
        page: 0,
        size: 50
      };
      setLoading(true);
      const url = `inventory/item`;
      const { data } = await query(url, qs);
      setLoading(false);
      setItems(data.content);
    }
    getAllItems();
  }, [departmentId, categoryId, flag])

  return { loading, items };
}

export const useCreateItem = () => {
  const createItem = async (itemData, file = null) => {
    const url = `inventory/item`;
    const formData = new FormData();
    
    // Add item data as JSON blob
    formData.append('item', new Blob([JSON.stringify(itemData)], { type: 'application/json' }));
    
    // Add file if provided
    if (file) {
      formData.append('form', file);
    }
    
    const { message } = await mutate(url, true, formData, {}, 'multipart/form-data', true);
    return message;
  }
  return createItem;
}

export const useUpdateItem = () => {
  const updateItem = async (id, itemData, file = null) => {
    const url = `inventory/item/${id}`;
    const formData = new FormData();
    
    // Add item data as JSON blob
    formData.append('item', new Blob([JSON.stringify(itemData)], { type: 'application/json' }));
    
    // Add file if provided
    if (file) {
      formData.append('form', file);
    }
    
    const { message } = await update(url, formData, {}, 'multipart/form-data', true);
    return message;
  }
  return updateItem;
}

export const useDeleteItem = () => {
  const deleteItem = async (id) => {
    const url = `inventory/item/${id}`;
    const { message } = await destroy(url);
    return message;
  }
  return deleteItem;
}

export const useUploadItems = () => {
  const uploadItems = async (formData) => {
    const url = `inventory/item/upload`;
    const { message } = await uploadFile(url, formData);
    return message;
  }
  return uploadItems;
}

export const useSearchItems = (keyword, page, size, flag) => {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(false);
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 10,
    total: 0
  });

  useEffect(() => {
    const search = async () => {
      if (!keyword) return;

      setLoading(true);
      const data = await searchItems(keyword, page, size);
      setLoading(false);

      if (data && data.content) {
        setItems(data.content);
        setPagination({
          current: data.number + 1,
          pageSize: data.size,
          total: data.totalElements
        });
      }
    }
    search();
  }, [keyword, page, size, flag]);

  return { loading, items, pagination };
}
